import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import { css } from 'styled-components';
import { focusOutlinesStyles, getHexToRgb } from "./../core";
import { StyledCheckboxIndicator } from "./elements";
var disabledStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  fill: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.color.text.light.disabled.value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.text.light.disabled.value;
});
export var checkboxStateStylesDefault = function checkboxStateStylesDefault(isDisabled) {
  return {
    active: isDisabled ? [] : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", " {\n          &::after {\n            background-color: ", ";\n          }\n        }\n      "])), StyledCheckboxIndicator, function (_ref3) {
      var theme = _ref3.theme;
      return theme.color.state.dark.pressed.value;
    }),
    "default": css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""]))),
    disabled: disabledStyles,
    focus: isDisabled ? [] : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", " {\n          &::after {\n            background-color: ", ";\n            ", ";\n          }\n        }\n      "])), StyledCheckboxIndicator, function (_ref4) {
      var theme = _ref4.theme;
      return theme.color.state["default"].focus.value;
    }, focusOutlinesStyles.dark),
    hover: isDisabled ? [] : css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        ", " {\n          &::after {\n            background-color: ", ";\n          }\n        }\n      "])), StyledCheckboxIndicator, function (_ref5) {
      var theme = _ref5.theme;
      return theme.color.state["default"].hover.value;
    })
  };
};
export var checkboxStateStylesSelected = function checkboxStateStylesSelected(isDisabled) {
  return {
    active: isDisabled ? [] : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        ", "\n      "])), function (_ref6) {
      var theme = _ref6.theme;
      var color = "rgba(".concat(getHexToRgb(theme.color.primary[500].value), ", 0.25)");
      return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", " {\n              &::after {\n                background-color: ", ";\n              }\n            }\n          "])), StyledCheckboxIndicator, color);
    }),
    "default": css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""]))),
    disabled: disabledStyles,
    focus: isDisabled ? [] : css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        ", " {\n          &::after {\n            background-color: ", ";\n            ", ";\n          }\n        }\n      "])), StyledCheckboxIndicator, function (_ref7) {
      var theme = _ref7.theme;
      return theme.color.state.primary.focus.value;
    }, focusOutlinesStyles.primary),
    hover: isDisabled ? [] : css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        ", " {\n          &::after {\n            background-color: ", ";\n          }\n        }\n      "])), StyledCheckboxIndicator, function (_ref8) {
      var theme = _ref8.theme;
      return theme.color.state.primary.hover.value;
    })
  };
};
export var getStateStyles = function getStateStyles(isSelected, isDisabled) {
  return isSelected ? checkboxStateStylesSelected(isDisabled) : checkboxStateStylesDefault(isDisabled);
};